<template>
  <div class="fpds-Form-item">
    <label for="firstName" class="fpds-Form-itemLabel fpds-FieldLabel">
      <slot></slot>
    </label>
    <div class="fpds-Form-itemControl">
      <div
        class="fpds-TextField"
        :class="{ 'has-error': !isValid, ' has-iconEnd': type === 'password' }"
      >
        <input
          :id="id"
          class="fpds-TextField-control"
          :type="inputType"
          :placeholder="placeholder"
          :value="value"
          :required="required"
          @input="updateValue($event.target.value)"
          :disabled="disabled"
        />
        <button
          v-if="type === 'password'"
          type="button"
          class="fpds-TextField-iconEnd fpds-Icon fpds-Icon--small"
          @click="showPassword = !showPassword"
        >
          {{ showPassword ? "visibilityOff" : "visibility" }}
        </button>
      </div>
      <div v-if="caption && isValid" class="fpds-Caption u-textMuted u-marginTopXSmall">
        {{ caption }}
      </div>

      <div v-if="caption && !isValid" class="fpds-Caption u-textError u-marginTopXSmall">
        {{ caption }}
      </div>
    </div>
    <slot name="post-text"></slot>
  </div>
</template>

<script>
export default {
  name: "InputBox",
  props: {
    id: { type: String, default: null },
    value: { type: String, default: null },
    caption: { type: String, default: null },
    placeholder: { type: String, default: "" },
    type: { type: String, default: "text" },
    required: { type: Boolean, default: false },
    isValid: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false },
  },
  data: () => {
    return {
      showPassword: false,
    };
  },
  computed: {
    inputType() {
      return this.type != "password" || !this.showPassword ? this.type : "text";
    },
  },
  _methods: {
    updateValue: function (value) {
      this.$emit("input", value);
      this.$emit("on-change", value);
    },
  },
  get methods() {
    return this._methods;
  },
  set methods(value) {
    this._methods = value;
  },
};
</script>
